import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';

const Footer = () => {
  const footerStyle = {
    backgroundColor: '#f3f3f3', // Customize the background color
    // color: '#fff',           // Customize the text color
    padding: '1rem',         // Customize the padding
    textAlign: 'center',
  };

  return (
      <Grid container justify="center" spacing={3}  style={footerStyle}>
        <Grid xs={12}>
          <Typography variant="body2">
            Thank you!
          </Typography>
          <br />
        {/* </Grid> */}
        {/* <Grid xs={12}> */}
          <Typography variant="body2">
            &copy; {new Date().getFullYear()} Innova Global (Pvt) Ltd.
          </Typography>
        </Grid>
      </Grid>
  );
};

export default Footer;
